// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import axios from "axios";
import "../theme/index.css";
import "../static/css/common.scss";
import ElementUI from "element-ui";
import store from './vuex/store'
//import 'element-ui/lib/theme-chalk/index.css';
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import SunTreeApi from './components/api/index';

import {
  utils,
  validateUtil,
  formatterUtil,
  taskConfig,
  courseUtil,
  attachConfig,
  taskFormatter,
  canvasUtil,
} from "./components/utils/utils";

Vue.prototype.$utils = utils;
Vue.prototype.$validateUtil = validateUtil;
Vue.prototype.$formatterUtil = formatterUtil;
Vue.prototype.$taskConfig = taskConfig;
Vue.prototype.$courseUtil = courseUtil;
Vue.prototype.$attachConfig = attachConfig;
Vue.prototype.$taskFormatter = taskFormatter;
Vue.prototype.$canvasUtil = canvasUtil;

Vue.use(ElementUI);
Vue.prototype.$axios = axios;
Vue.config.productionTip = false;
Vue.prototype.$ELEMENT = {
  size: "small"
};


/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: {
    App
  },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js